/**
 * Medios de pago — etiquetas y listas canónicas para toda la UI (caja,
 * recibo, reportes, diálogo de cobro). La fuente es `@atreus/core`; acá
 * solo se adaptan a lookups por string (los rows del worker traen
 * `method: string`).
 */

import {
  paymentMethodLabels as corePaymentMethodLabels,
  type CollectionMethod,
  type PaymentMethod,
} from '@atreus/core';

export const paymentMethodLabels: Record<string, string> = corePaymentMethodLabels;

export const paymentMethodLabel = (method: string): string =>
  paymentMethodLabels[method] ?? method;

/** Orden de presentación de todos los medios (incluye fiado). */
export const PAYMENT_METHODS: readonly PaymentMethod[] = [
  'cash',
  'card',
  'transfer',
  'nequi',
  'daviplata',
  'credit',
];

/** Medios con los que entra dinero real — los únicos válidos para abonos. */
export const COLLECTION_METHODS: readonly CollectionMethod[] = [
  'cash',
  'card',
  'transfer',
  'nequi',
  'daviplata',
];
